/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Web_Scraping_Architect_Output9Inputs */

const en_svc_web_scraping_architect_output9 = /** @type {(inputs: Svc_Web_Scraping_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extraction design`)
};

const ar_svc_web_scraping_architect_output9 = /** @type {(inputs: Svc_Web_Scraping_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصميم الاستخراج`)
};

const bn_svc_web_scraping_architect_output9 = /** @type {(inputs: Svc_Web_Scraping_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এক্সট্রাকশন ডিজাইন`)
};

const de_svc_web_scraping_architect_output9 = /** @type {(inputs: Svc_Web_Scraping_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extraktionsdesign`)
};

const es_svc_web_scraping_architect_output9 = /** @type {(inputs: Svc_Web_Scraping_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diseño de extracción`)
};

const fr_svc_web_scraping_architect_output9 = /** @type {(inputs: Svc_Web_Scraping_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conception d'extraction`)
};

const pt_svc_web_scraping_architect_output9 = /** @type {(inputs: Svc_Web_Scraping_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projeto de extração`)
};

const zh_svc_web_scraping_architect_output9 = /** @type {(inputs: Svc_Web_Scraping_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提取设计`)
};

const tr_svc_web_scraping_architect_output9 = /** @type {(inputs: Svc_Web_Scraping_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çıkarma tasarımı`)
};

const ru_svc_web_scraping_architect_output9 = /** @type {(inputs: Svc_Web_Scraping_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дизайн извлечения`)
};

const pl_svc_web_scraping_architect_output9 = /** @type {(inputs: Svc_Web_Scraping_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt ekstrakcji`)
};

/**
* | output |
* | --- |
* | "Extraction design" |
*
* @param {Svc_Web_Scraping_Architect_Output9Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_web_scraping_architect_output9 = /** @type {((inputs?: Svc_Web_Scraping_Architect_Output9Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Web_Scraping_Architect_Output9Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_web_scraping_architect_output9(inputs)
	if (locale === "bn") return bn_svc_web_scraping_architect_output9(inputs)
	if (locale === "de") return de_svc_web_scraping_architect_output9(inputs)
	if (locale === "es") return es_svc_web_scraping_architect_output9(inputs)
	if (locale === "fr") return fr_svc_web_scraping_architect_output9(inputs)
	if (locale === "pt") return pt_svc_web_scraping_architect_output9(inputs)
	if (locale === "zh") return zh_svc_web_scraping_architect_output9(inputs)
	if (locale === "tr") return tr_svc_web_scraping_architect_output9(inputs)
	if (locale === "ru") return ru_svc_web_scraping_architect_output9(inputs)
	if (locale === "pl") return pl_svc_web_scraping_architect_output9(inputs)
	return en_svc_web_scraping_architect_output9(inputs)
});
export { svc_web_scraping_architect_output9 as "svc_web-scraping_ARCHITECT_output" }